<script>
/* eslint-env browser */
import { useAccount } from 'dashboard/composables/useAccount';
import { useBranding } from 'shared/composables/useBranding';
import { mapGetters } from 'vuex';

export default {
  setup() {
    const { accountId } = useAccount();
    const { replaceInstallationName } = useBranding();
    return {
      accountId,
      replaceInstallationName,
    };
  },

  data() {
    return {
      errorStateMessage: this.$route.query.error,
    };
  },

  computed: {
    ...mapGetters({
      globalConfig: 'globalConfig/get',
    }),
  },

  methods: {
    async shopeeAuthorize() {
      let redirectUri = `${window.location.origin}/shopee/callback/${this.accountId}`;
      const authUri = `https://open.shopee.com/auth?auth_type=seller&response_type=code&partner_id=${window.chatwootConfig.shopeePartnerId}&redirect_uri=${redirectUri}`;
      window.location.href = authUri;
    },
  },
};
</script>

<template>
  <div
    class="border border-n-weak bg-n-solid-1 rounded-t-lg border-b-0 h-full w-full p-6 col-span-6 overflow-auto"
  >
    <div class="flex flex-col items-center justify-center h-full text-center">
      <p class="text-danger mb-5 text-red-400">
        {{ errorStateMessage }}
      </p>
      <a
        href="#"
        class="button icon-button rounded-md flex justify-center items-center gap-2 bg-white dark:bg-slate-900 text-slate-800 dark:text-slate-100 hover:bg-slate-100 dark:hover:bg-slate-800 border border-solid border-slate-200 dark:border-slate-700 hover:border-woot-500 dark:hover:border-woot-500 transition-all duration-200 ease-in px-4 py-2"
        @click="shopeeAuthorize()"
      >
        <img
          width="24"
          src="~dashboard/assets/images/channels/shopee_connect.png"
          alt="Shopee-logo"
        />
        <span>{{ $t('INBOX_MGMT.ADD.SHOPEE.CONNECT') }}</span>
      </a>
      <p class="py-6">
        {{
          replaceInstallationName(
            $t('INBOX_MGMT.ADD.SHOPEE.HELP'),
            globalConfig.installationName
          )
        }}
      </p>
    </div>
  </div>
</template>
